import { useEffect, useMemo, useState } from 'react';
import { OnFormSubmitProp } from '@shared/types/frontend/sendFunds';
import { CovalentBalanceItem } from '@shared/types/frontend';
import { toSpecialFixed } from '@/lib/misc/utils';
import NumberPad from '@/components/trade/NumberPad';
import SelectPercentage from '@/components/trade/mobile/SelectPercentage';
import FromAssetsAmountSelection from '@/components/trade/swap-home/FromAssetsAmountSelection';
export default function KeypadController({
  tokenUserBalance,
  form
}: {
  tokenUserBalance: CovalentBalanceItem;
  form: OnFormSubmitProp['form'];
}) {
  const [isSwitched, setIsSwitched] = useState(false);
  const _watchTokenAmount = form.watch('tokenAmount');
  const _watchTokenUsdAmount = form.watch('tokenUsdAmount');
  const _isMaxBalanceInputed = useMemo(() => {
    if (!tokenUserBalance) return false;
    const [_maxTokenBalance, _maxUsdBalance] = [parseFloat(_watchTokenAmount) >= tokenUserBalance.formatted_balance, parseFloat(_watchTokenUsdAmount) >= tokenUserBalance.usd_value];
    if (_watchTokenAmount === '0' || _watchTokenUsdAmount === '0') {
      return false;
    }
    if (_maxTokenBalance || _maxUsdBalance) {
      return true;
    }
    return false;
  }, [tokenUserBalance, _watchTokenAmount, _watchTokenUsdAmount]);
  useEffect(() => {
    if (_isMaxBalanceInputed) {
      form.setValue('tokenAmount', toSpecialFixed(tokenUserBalance.formatted_balance, 3, false, false).value);
      form.setValue('tokenUsdAmount', toSpecialFixed(tokenUserBalance.usd_value, 3, false, false).value);
      return;
    }
  }, [_isMaxBalanceInputed]);
  function handleAssetPercentage(percentage: number) {
    const amountToken = Number(tokenUserBalance?.formatted_balance * (percentage / 100));
    console.log('SendFunds: getQuoteAndTransferParams percentage amount in token', toSpecialFixed(amountToken, 3, false, false).value);
    form.setValue('tokenAmount', toSpecialFixed(amountToken, 3, false, false).value);
    form.setValue('tokenUsdAmount', toSpecialFixed(amountToken * tokenUserBalance.quote_rate, 3, false, false).value);
  }
  const handleNumPadChange = (val: string, isSwitched: boolean) => {
    if (!val) {
      val = '0';
    }
    if (val.length === 0) {
      val = '0';
    }
    if (val?.includes('.')) {
      const parts = val.split('.');
      const integerPart = parts[0];
      let decimalPart = parts[1] || '';
      const decimalLength = decimalPart.length;
      if (decimalLength > 3) {
        decimalPart = decimalPart.substring(0, 3);
      }
      val = `${integerPart}.${decimalPart}`;
    }
    const parsedVal = parseFloat(val.replace(/,/g, ''));
    if (isNaN(parsedVal)) {
      console.error('Invalid numeric input:', val);
      return;
    }
    if (isSwitched) {
      form.setValue('tokenAmount', val);
      const tokenToUsd = toSpecialFixed(parsedVal * tokenUserBalance.quote_rate).value;
      form.setValue('tokenUsdAmount', isNaN(parseFloat(tokenToUsd)) ? '0' : tokenToUsd);
    } else {
      form.setValue('tokenUsdAmount', val);
      const usdToToken = toSpecialFixed(parsedVal / tokenUserBalance.quote_rate).value;
      form.setValue('tokenAmount', usdToToken);
    }
  };
  return <div className='flex flex-col gap-4' data-sentry-component="KeypadController" data-sentry-source-file="KeypadController.tsx">
      <FromAssetsAmountSelection totalAmount={isSwitched ? _watchTokenAmount : _watchTokenUsdAmount}
    // Temporary adaptation to use the same FromAssetsAmountSelection as the Swap/Buy/Sell
    // All of the Send logic should be refactored to remove the usage of Zod Forms
    asset={tokenUserBalance} isSwitched={isSwitched} setIsSwitched={setIsSwitched} enableSwitch data-sentry-element="FromAssetsAmountSelection" data-sentry-source-file="KeypadController.tsx" />
      <SelectPercentage setPercentage={handleAssetPercentage} data-sentry-element="SelectPercentage" data-sentry-source-file="KeypadController.tsx" />
      <NumberPad value={_watchTokenUsdAmount} tokenAmountToSend={_watchTokenAmount} onValueChange={handleNumPadChange} isSwitched={isSwitched} data-sentry-element="NumberPad" data-sentry-source-file="KeypadController.tsx" />
    </div>;
}